import { render, staticRenderFns } from "./SearchSuggestion.vue?vue&type=template&id=3677042e&scoped=true"
import script from "./SearchSuggestion.vue?vue&type=script&lang=js"
export * from "./SearchSuggestion.vue?vue&type=script&lang=js"
import style0 from "./SearchSuggestion.vue?vue&type=style&index=0&id=3677042e&prod&lang=css"
import style1 from "./SearchSuggestion.vue?vue&type=style&index=1&id=3677042e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677042e",
  null
  
)

export default component.exports